<template>
	<table class="table table-bordered m-table bet-ratio-table">
	   	<thead>
	      	<tr>
				<th :colspan="totalChannel*(totalColumn+1)">{{title}}</th>
			</tr>
			<tr>
				<th v-for="(channel, idx) in channels" :colspan="totalColumn+1">{{channel.text}}</th>
			</tr>
			<tr>
				<template v-for="g in totalChannel">
					<th>Số</th>
					<th v-for="(h,idx) in header">{{h.value}}</th>
				</template>
			</tr>
	   	</thead>
	   	<tbody>
	     	<tr v-for="(obj, number) in tableData">
	     		<template v-for="(channel, cidx) in channels">
	     			<td class="number-container">{{ obj[channel.id] ? number : ""}}</td>
	     			<td v-for="(h, hidx) in header">{{ obj[channel.id] && obj[channel.id][h.key] ? formatNumber(obj[channel.id][h.key][0]['pt']) : ""}}</td>
	     		</template>
	     	</tr>
	   	</tbody>
	</table>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import { Utilities } from '../utilities';
	import groupBy from 'lodash/groupBy';

	export default {
		props: ['game', 'type', 'title', 'header', 'channels', 'data'],

		data(){
			let vm = this;

	        return {
	        	totalChannel: this.channels.length,
	        	totalColumn: this.header.length,
	        	tableData: []
	        }
	    },

	    // components: {
     //    	'data-table': DataTable
     //    },

        mounted(){
        	
        },

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

		watch: {
			header: function(val){
				if(!val) return;
				this.totalColumn = val.length;
			},
			channels: function(val){
				if(!val) return;
				this.totalChannel = val.length;
			},
			data: function(val){
				let d = this.filterDataByType(val);
				d = this.groupByNumber(d);
				d = this.groupByChannel(d);

				this.tableData = d;
			}
		},

	    methods: {
	    	propToNameGroup: function(propId){
	    		propId = parseInt(propId);

	    		switch(propId){
	    			case 1:
	    			case 6:
	    				return "dau";
	    			case 2:
	    			case 7:
	    			case 11:
	    				return "duoi";
	    			case 3:
						return this.game != 1 ? "7lo" : "blo";
	    			case 8:
						return this.game != 1 ? "7lo" : "blo";
					case 4:
	    			case 5:
	    			case 9:
	    			case 10:
					case 12:
					case 13:
						return "blo";
					case 14:
					case 15:
					case 16:
						return "da";
					case 17:
					case 18:
					case 19:
						return "dx";
	    		}
	    	},
	        filterDataByType: function(data){
	        	let vm = this;

	        	let d = data.map(e => {
	        		e.type = Utilities.propGroupToName(e.p);
	        		return e;
	        	});

	        	d = d.filter(e => {
	        		return e.type == vm.type;
	        	});

	        	return d;
	        },
	        groupByNumber: function(data){
	        	let d = groupBy(data, function(val){
	    			return val.n;
	    		});

	    		return d;
	        },
	        groupByProps: function(dataGroupByChannel){
	        	let vm = this;
	        	for(let channel in dataGroupByChannel){
	        		let dataGroupByProp = groupBy(dataGroupByChannel[channel], function(val){
		    			return vm.propToNameGroup(val.p);
		    		});
		    		dataGroupByChannel[channel] = dataGroupByProp;
	        	}
	        	

	    		return dataGroupByChannel;
	        },
	        groupByChannel: function(data){
	        	let vm = this;
	        	for(let number in data){
	        		let dataGroupByChannel = groupBy(data[number], function(val){
		    			return val.c;
		    		});
		    		dataGroupByChannel = this.groupByProps(dataGroupByChannel);
		    		data[number] = dataGroupByChannel;
	        	}

	    		return data;
	        },
	        formatNumber: function(n){
	        	return Utilities.formatNumber(n);
	        },
	        processData: function(data){
	        	let d = {};

	        	for(let i=0;i<data.length;i++){
	        		if(!d[data[i].n]){
	        			d[data[i].n] = {};

	        			for(let j=0;j<this.header.length;j++){
	        				d[data[i].n][this.header[j]]
	        			}
	        			
	        		}
	        	}


	        	for(let i=0;i<this.channels.length;i++){
	        		let channel = this.channels[i].id;
	        		let dd = [];

	        		for(let j=0;j<this.header.length;j++){
	        			let header = this.header[j];
	        			let hasNumber = false;

	        			for(let k=0;k<data.length;k++){
	        				if(data[k].c != channel) continue;
	        				if(header.id.indexOf( data[k].p ) < 0) continue;

	        				if(!hasNumber) {
	        					dd.push(data[k].n);
	        					hasNumber = true;
	        				}

	        				dd.push(data[k].pt);
	        			}

	        			if(dd.length < this.header.length){
		        			for(let l=0;l<this.header.length - dd.length;l++){
		        				dd.push("");
		        			}
		        		}
	        		}

	        		

	        		d.push(dd);
	        	}

	        	return d;
	        }
	    }
	}

</script>

<style>
	.number-container{
	    font-size: 15px;
	    font-weight: 500;
	    color: blue;
		background: #f4f3f5;
		border: 1px solid #e5e6ea;
	}
</style>
